<template>
	<b-modal centered hide-footer size="lg" :title="titleModal" v-model="isActive" @hidden="handleHidden">
		<b-overlay :show="isLoading">
			<b-table-simple sticky-header="40vh">
				<b-thead class="text-center">
					<b-tr>
						<b-th>Creado por</b-th>
						<b-th>Kilogramos</b-th>
						<b-th>Libras</b-th>
					</b-tr>
				</b-thead>
				<b-tbody class="text-center">
					<b-tr v-for="row in rows" :key="row.id">
						<b-td>
							<p class="mb-0">{{ row.created_by.user }}</p>
							<p class="mb-0">{{ row.created_by.date | myGlobalDayShort }}</p>
						</b-td>
						<b-td>{{ row.kg_weight }}</b-td>
						<b-td>{{ row.pounds_weight }}</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
	</b-modal>
</template>

<script>
import preparacionService from "@/services/preparacion/default.service.js";

export default {
	props: {
		show: Boolean,
		info: Object,
	},
	data: () => ({
		isActive: false,
		isLoading: false,
		rows: [],
	}),
	computed: {
		titleModal() {
			return this.info.specimen
				? `Pesos / ${this.info.specimen.alias ? this.info.specimen.alias : ""} (${this.info.specimen.plate})`
				: "";
		},
	},
	methods: {
		handleHidden() {
			this.isActive = false;
			this.$emit("closing");
		},
		async getRows() {
			this.isLoading = true;
			const { data } = await preparacionService.getTrackingWeights({
				training_id: this.info.training_id,
			});
			this.rows = data;
			this.isLoading = false;
		},
	},
	watch: {
		show(val) {
			if (val) {
				this.getRows();
				this.isActive = val;
			}
		},
	},
};
</script>
